var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-menu',{attrs:{"position-y":_vm.menuTop,"position-x":_vm.menuLeft,"transition":false,"items":_vm.contextMenuFiltered,"menu-props":{
    menuWidth: 0,
    lazy: true
  }},model:{value:(_vm.showContextMenu),callback:function ($$v) {_vm.showContextMenu=$$v},expression:"showContextMenu"}})}
var staticRenderFns = []

export { render, staticRenderFns }